import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Gestora } from '../consulta-usuarios/master-consulta-usuarios.models';
const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class MasterConsultaClientesService {
  constructor(private _$http: HttpClient) {}

  getClientes() {
    return this._$http
      .get<Gestora[]>(`${BASE_PATH}/bff/master/clients`)
      .toPromise();
  }

  getClientesStatus(status) {
    return this._$http
      .get<Gestora[]>(`${BASE_PATH}/bff/master/clients`, {
        params: { activeUsers: status },
      })
      .toPromise();
  }

  getClientesSearch(search, status) {
    return this._$http
      .get<Gestora[]>(`${BASE_PATH}/bff/master/clients`, {
        params: { isActive: status, name: search },
      })
      .toPromise();
  }
}
